import React from 'react';
import { JobOpeningsContainer } from './containers';

export const JobOpeningsView = () => {
  return <JobOpeningsContainer />;
};
